import { Vue, Component, Prop } from 'vue-property-decorator';
import { mixins } from 'vue-class-component';
import PictureMixin from '../../mixins/PictureMixin';
import UserMixin from '../../mixins/UserMixin';
import ArtworkMixin from '../../mixins/ArtworkMixin';
import { ajax } from 'rxjs/ajax';
import * as APIUtils from '../../utils/api';

/**
 * Home
 */
@Component({
    name: 'Mosaic',
    components: {
    },
})
export default class Mosaic extends mixins(PictureMixin, UserMixin, ArtworkMixin) {
    /**
     * Internal state
     */
    state: {[key: string]: any} = {
        artworks: [],
        drawerClose: true,
        modalClose: true,
        currentArtwork: null,
        artworkKeys: {
            // "artist" :  "Artist",
            // "title" :  "Title",
            date :  'Date',
            period : 'Period',
            medium :  'Medium',
            technique :  'Technique',
            inventoryNumber:  'Inventory number',
            mentions :  'Special mentions',
            size :  'Dimensions',
            bibliography :  'Bibliography',
            provenances :  'Provenance(s)',
            exhibitions :  'Exhibition(s)',
            notes :  'Notes',
        },
        carousselClose: true,
        carousselPosition: -1,
    };

    /**
     * Toggle the drawer
     */
    toggleDrawer() {
        this.state.drawerClose = !this.state.drawerClose;
    }

    /**
     * Open the modal
     */
    openModal(artwork: any) {
        this.state.modalClose = false;
        this.state.currentArtwork = artwork;
    }

    /**
     * Show picture in caroussel
     */
    showPicture(i: number) {
        this.state.carousselPosition = i;
        this.state.carousselClose = false;
    }

    /**
     * Handle a search through the drawer
     */
    onNewSearch(artworks: any[]) {
        this.state.artworks = artworks;
        this.state.carousselPosition = -1;
        this.state.carousselClose = true;
        this.state.modalClose = true;
    }
}
